import { Box } from "theme-ui";

export default function MapPinIcon(props) {
  return (
    <Box
      as="svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.1168 11.8769C15.6691 9.32457 15.6691 5.1865 13.1168 2.63421C10.5645 0.08193 6.42646 0.08193 3.87417 2.63421C1.32189 5.1865 1.32189 9.32457 3.87417 11.8769L8.49549 16.4982L13.1168 11.8769Z"
        stroke="black"
      />
      <circle cx="8.49561" cy="7.49817" r="2" stroke="black" />
    </Box>
  );
}
